<template>
  <div class="option-custom-wrap">
    <!-- 公共：无 / 自定义 单选组 -->
    <el-radio-group v-model="customType" @change="handleCustomTypeChange">
      <el-radio :label="1">无</el-radio>
      <el-radio :label="2">自定义</el-radio>
    </el-radio-group>

    <!-- ✅ 类型1：颜色选择器 (父组件传 type="color" 显示这个) -->
    <div v-if="customType == 2 && type === 'color'" class="custom-content">
      <div style="display: flex; align-items: center">
        <el-color-picker
          v-model="datas[field]"
          show-alpha
          @change="(val) => handleChange(val)"
        ></el-color-picker>
        <el-input placeholder="请输入背景颜色" v-model="datas[field]">
        </el-input>
      </div>
    </div>

    <!-- ✅ 类型2：跳转链接输入框 (父组件传 type="link" 显示这个) -->
    <div v-if="customType == 2 && type === 'link'" class="custom-content">
      <el-input
        type="textarea"
        v-model="datas[field]"
        placeholder="请输入跳转链接"
        maxlength="100"
        size="small"
        @input="(val) => handleChange(val)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkInput",
  // ✅ 父组件需要传递的3个props，按需传参，语义清晰
  props: {
    // 必传：数据源对象 (你的datas整体)
    datas: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 必传：组件类型 - color=颜色选择器  link=跳转链接输入框
    type: {
      type: String,
      required: true,
      validator: (val) => ["color", "link"].includes(val), // 校验只能传这两个值，防止传错
    },
    // 必传：要绑定的datas里的【指定字段名】 例：backgroundColor / link
    field: {
      type: String,
      required: true,
    },
    // 默认字段名
    defaultColor: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      // datas子组件里的默认背景颜色
      defaultBackgroundColor: null,
      // 单选框状态：1=无 2=自定义，初始化判断：字段有值则选自定义，否则选无
      customType: this.datas[this.field] ? 2 : 1,
    };
  },
  created() {
    const defaultBackgroundColor = this.datas[this.field];
    // 组件创建时，初始化默认背景颜色
    this.defaultBackgroundColor = defaultBackgroundColor;
  },
  watch: {
    // 监听单选切换
    customType(newVal) {
      if (newVal === 1) {
        this.datas[this.field] = "";
      }
    },
    // 监听datas对象的变化（替代原来的"datas[field]"）
    datas: {
      handler(newVal) {
        // 当目标字段变化时，同步单选状态
        this.customType = newVal[this.field] ? 2 : 1;
      },
      deep: true, // 开启深度监听，监听对象内部属性变化
      immediate: true, // 初始化时立即执行一次，确保初始状态正确
    },
  },
  methods: {
    // 自定义类型切换事件回调
    handleCustomTypeChange(newVal) {
      // 恢复成默认初始化相关颜色参数
      if (newVal == 1) {
        // 动态修改全局 CSS 变量 --theme-primary 这里需要判断哪些组件才能修改全局css变量值 只有标题栏组件才能修改全局css变量值
        if (this.field === "lineColor") {
          this.$utils.setCssVariable("theme-primary", this.datas[this.defaultColor]);
        }
        this.datas[this.field] = this.datas[this.defaultColor];
      }
      console.log(
        "LinkInput子组件handleCustomTypeChange事件回调",
        newVal,
        this.field,
        this.datas,
        this.defaultColor,
      );
    },
    // ✅ 核心：颜色选择器的change事件，完全复刻你要求的传参格式
    handleChange(val) {
      //  动态更新datas中对应变量的值 可不用再父组件中回调
      this.datas[this.field] = val;
      this.$emit("change", val, this.field);
      console.log(
        "LinkInput子组件handleChange背景颜色选择事件回调",
        val,
        this.field,
        this.datas,
      );
      // 动态修改全局 CSS 变量 --theme-primary 这里需要判断哪些组件才能修改全局css变量值 只有标题栏组件才能修改全局css变量值
      if (this.field === "bgColor" || this.field === "lineColor") {
        this.$utils.setCssVariable("theme-primary", val);
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 样式完全复用你原有的，间距一致，无缝适配父组件布局
.option-custom-wrap {
  width: 100%;
  .custom-content {
    margin-top: 8px;
  }
}
</style>
